export const SIGNUP_ITEM_TABS = Object.freeze({
  info: "info",
  fundIt: "fund-it",
  respondents: "respondents",
  additionalInfo: "additional-info",
});
